import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import Spinner from '../../../spinner/spinner';
import Overview from './overview';
import { getChurch } from './queries/church';

class OverviewPage extends Component {
  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      return <Overview church={this.props.data.church} />;
    }
  }
}

export default graphql(getChurch, {
  options: ({ selectedChurch }) => ({ variables: { id: selectedChurch.id } })
})(OverviewPage);



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/overview/overviewPage.js